export const appendBranchIdForContributionBranch = (
  id: string,
  name: string,
  contribution: boolean,
): string => {
  if (!contribution) {
    return name;
  }

  const branchId = `csb-${id}`;
  const prefix = `${branchId}/`;

  if (name.startsWith(prefix)) {
    return name;
  }

  return `${prefix}${name}`;
};

export const removeBranchIdForContributionBranch = (
  id: string,
  name: string,
  contribution: boolean,
): string => {
  if (!contribution) {
    return name;
  }

  const branchId = `csb-${id}`;
  const prefix = `${branchId}/`;

  if (name.startsWith(prefix)) {
    return name.replace(prefix, "");
  }

  return name;
};
